import { createSlice } from "@reduxjs/toolkit";
import { sortData } from "../../common/SortSupport";

let initialData: any = {
    searchString: '',
    criteriaGroups: null,
    currentSection: '',
    saCriteria: null,
    selectedSaCriteria: null,
    saStandards: null,
    saActions: null,
    saEvidences: null,
    saComments: null,
    offSiteEvaluation: null,
    offSiteCriteria: [],
    selectedOffSiteCriteria: null,
    offSiteStandards: null,
    onSiteCriteria: null,
    onSiteDateGroups: [],
    selectedOnSiteCriteria: null,
    selectedOnSiteSession: null,
    onSiteStandards: null,
    evalReportCriteria: [],
    selectedEvalReportCriteria: {},
    evalReportStandards: [],
    actionsList: [],
    staffList: [],
    projectList: [],
    departmentList: [],
    newSaAction: {},
    clubEvaluationTabs: [
        'EVALUATION',
        'REPORTS'
    ],
    jlEvaluationTabs: [
        'EVALUATION',
        'ON_SITE',
        'REPORTS'
    ],
    currentEvaluationTab: 'EVALUATION',
    saCriteriaActions: [],
    saCriteriaEvidences: [],
    saCriteriaComments: [],
    offSiteCriteriaComments: [],
    onSiteCriteriaComments: [],
    evalCriteriaComments: [],
    commentContent: null,
    criteriaComment: {
        selfAssessmentComment: '',
        offSiteComment: '',
        onSiteComment: '',
        interimReportComment: '',
        finalReportComment: '',
    },
    selectedCommentPhase: 'SELECT_COMMENT_PHASE',
    commentPhases: ['OFF_SITE', 'ON_SITE', 'INTERIM_REPORT', 'FINAL_REPORT', 'SELF_ASSESSMENT'],
    selectedChatPhase: 'SELF_ASSESSMENT',
    selectedStandardsChat: {},
    interviewDetails: null,
    isFetchingInterviewDetails: false,
    interviewers: [],
    interviewTeams: [],
    interviewView: 'LIST',
    reportFolders: null,
    selectedReportEntity: null,
    isSelectedReport: false,
    reportData: null,
    executiveSummaryRichText: null,
    standardStatuses: null,
    selectedERStandard: null,
    selctedOffSiteStandard: null,
    selectedSaStandard: null,
    commentBoxTabs: [],
    selectedCommentBoxTab: null,
    onSiteCommentBoxTabs: [],
    onSiteSelectedCommentBoxTab: null,
    structuredReportFolders: null,
    criteriaCommentsHistory: null,
}

export const evaluation = createSlice({
    name: 'evaluation',
    initialState: initialData,
    reducers: {
        setEvaluationSearchString: (state: any, action: any) => {
            state.searchString =  action.payload;
            return state;
        },
        setCriteriaGroups: (state: any, action: any) => {
            state.criteriaGroups =  action.payload;
            return state;
        },
        updateCurrentSection: (state: any, action: any) => {
            state.currentSection =  action.payload;
            return state;
        },
        setInitialSection: (state: any) => {
            state.currentSection = initialData.currentSection;
            return state;
        },
        setSaCriteria: (state: any, action: any) => {
            var tempArr = action.payload;
            if(tempArr?.length > 0) {
                tempArr = sortData(action.payload, 'uid', 'asc')
            }
            state.saCriteria = tempArr;
            return state;
        },
        setSaStandards: (state: any, action: any) => {
            var tempArr = action.payload;
            if(tempArr && tempArr?.length > 0) {
                tempArr = sortData(action.payload, 'uid', 'asc')
            }
            state.saStandards = tempArr;
            return state;
        },
        resetSaStandards: (state: any) => {
            state.saStandards = initialData.saStandards;
            return state;
        },
        setSelectedSaCriteria: (state: any, action: any) => {
            state.selectedSaCriteria = action.payload;
            return state;
        },
        resetSelectedSaCriteria: (state: any) => {
            state.selectedSaCriteria = initialData.selectedSaCriteria;
            return state;
        },
        setSaActions: (state: any, action: any) => {
            state.saActions = action.payload;
            return state;
        },
        resetSaActions: (state: any) => {
            state.saActions = initialData.saActions;
            return state;
        },
        setOffSiteEvaluation: (state: any, action: any) => {
            state.offSiteEvaluation = action.payload;
            return state;
        },
        resetOffSiteEvaluation: (state: any) => {
            state.offSiteEvaluation = initialData.saEvidences;
            return state;
        },
        setSaEvidences: (state: any, action: any) => {
            state.saEvidences = action.payload;
            return state;
        },
        resetSaEvidences: (state: any) => {
            state.saEvidences = initialData.saEvidences;
            return state;
        },
        setSaComments: (state: any, action: any) => {
            state.saComments = action.payload;
            return state;
        },
        resetSaComments: (state: any) => {
            state.saEvidences = initialData.saEvidences;
            return state;
        },
        setOffSiteCriteria: (state: any, action: any) => {
            state.offSiteCriteria =  action.payload;
            return state;
        },
        setOffSiteStandards: (state: any, action: any) => {
            var tempArr = action.payload;
            if(tempArr && tempArr?.length > 0) {
                tempArr = sortData(action.payload, 'uid', 'asc')
            }
            state.offSiteStandards = tempArr;
            return state;
        },
        resetOffSiteStandards: (state: any) => {
            state.offSiteStandards = initialData.offSiteStandards;
            return state;
        },
        setSelectedOffSiteCriteria: (state: any, action: any) => {
            state.selectedOffSiteCriteria = action.payload;
            return state;
        },
        resetSelectedOffSiteCriteria: (state: any) => {
            state.selectedOffSiteCriteria = initialData.selectedOffSiteCriteria;
            return state;
        },
        setOnSiteCriteria: (state: any, action: any) => {
            state.onSiteCriteria =  action.payload;
            return state;
        },
        setOnSiteDateGroups: (state: any, action: any) => {
            state.onSiteDateGroups =  action.payload;
            return state;
        },
        setInterviewDetails: (state: any, action: any) => {
            state.interviewDetails =  action.payload;
            return state;
        },
        resetInterviewDetails: (state: any) => {
            state.interviewDetails =  initialData.interviewDetails;
            return state;
        },
        setOnSiteStandards: (state: any, action: any) => {
            state.onSiteStandards = action.payload;
            return state;
        },
        resetOnSiteStandards: (state: any) => {
            state.onSiteStandards = initialData.onSiteStandards;
            return state;
        },
        setSelectedOnSiteCriteria: (state: any, action: any) => {
            state.selectedOnSiteCriteria = action.payload;
            return state;
        },
        resetSelectedOnSiteCriteria: (state: any) => {
            state.selectedOnSiteCriteria = initialData.selectedOnSiteCriteria;
            return state;
        },
        setSelectedOnSiteSession: (state: any, action: any) => {
            state.selectedOnSiteSession = action.payload;
            return state;
        },
        resetSelectedOnSiteSession: (state: any) => {
            state.selectedOnSiteSession = initialData.selectedOnSiteSession;
            return state;
        },
        setInterviewers: (state: any, action: any) => {
            state.interviewers = action.payload;
            return state;
        },
        setInterviewView: (state:any, action) => {
            state.interviewView = action.payload;
            return state;
        },
        setInterviewTeams: (state: any, action: any) => {
            state.interviewTeams = action.payload;
            return state;
        },
        setEvalReportCriteria: (state: any, action: any) => {
            state.evalReportCriteria =  action.payload;
            return state;
        },
        setEvalReportStandards: (state: any, action: any) => {
            state.evalReportStandards = action.payload;
            return state;
        },
        resetEvalReportStandards: (state: any) => {
            state.evalReportStandards = initialData.evalReportStandards;
            return state;
        },
        setSelectedEvalReportCriteria: (state: any, action: any) => {
            state.selectedEvalReportCriteria = action.payload;
            return state;
        },
        resetSelectedEvalReportCriteria: (state: any) => {
            state.selectedEvalReportCriteria = initialData.selectedEvalReportCriteria;
            return state;
        },
        setActionsList: (state: any, action: any) => {
            state.actionsList = action.payload;
            return state;
        },
        resetActionsList: (state: any) => {
            state.actionsList = initialData.actionsList;
            return state;
        },
        setStaffList: (state: any, action: any) => {
            state.staffList = action.payload;
            return state;
        },
        resetStaffList: (state: any) => {
            state.staffList = initialData.staffList;
            return state;
        },
        setProjectList: (state: any, action: any) => {
            state.projectList = action.payload;
            return state;
        },
        resetProjectList: (state: any) => {
            state.projectList = initialData.projectList;
            return state;
        },
        setDepartmentList: (state: any, action: any) => {
            state.departmentList = action.payload;
            return state;
        },
        resetDepartmentList: (state: any) => {
            state.departmentList = initialData.projectList;
            return state;
        },
        addNewSaAction: (state: any, action: any) => {
            state.newSaAction = action.payload;
            return state;
        },
        resetAddNewSaAction: (state: any) => {
            state.newSaAction = initialData.newSaAction;
            return state;
        },
        setCurrentEvaluationTab: (state:any, action:any) => {
            state.currentEvaluationTab = action.payload;
            return state;
        },
        setCriteriaActions: (state:any, action:any) => {
            state.saCriteriaActions = action.payload;
            return state;
        },
        resetCriteriaActions: (state:any) => {
            state.saCriteriaActions = initialData.saCriteriaActions;
            return state;
        },
        setCriteriaEvidences: (state:any, action:any) => {
            state.saCriteriaEvidences = action.payload;
            return state;
        },
        setSaCriteriaComments: (state:any, action:any) => {
            state.saCriteriaComments = action.payload;
            return state;
        },
        setOffSiteCriteriaComments: (state:any, action:any) => {
            state.offSiteCriteriaComments = action.payload;
            return state;
        },
        setOnSiteCriteriaComments: (state:any, action:any) => {
            state.onSiteCriteriaComments = action.payload;
            return state;
        },
        setEvalCriteriaComments: (state:any, action:any) => {
            state.evalCriteriaComments = action.payload;
            return state;
        },
        setCommentContent: (state:any, action:any) => {
            state.commentContent = action.payload;
            return state;
        },
        resetCommentContent: (state:any) => {
            state.commentContent = initialData.criteriaComment;
            return state;
        },
        setSelectedCommentPhase: (state:any, action:any) => {
            state.selectedCommentPhase = action.payload;
            return state;
        },
        resetSelectedCommentPhase: (state:any) => {
            state.selectedCommentPhase = initialData.selectedCommentPhase;
            return state;
        },
        setCriteriaComment: (state:any, action:any) => {
            state.criteriaComment = action.payload;
            return state;
        },
        resetCriteriaComment: (state:any) => {
            state.criteriaComment = initialData.criteriaComment;
            return state;
        },
        setSelectedChatPhase: (state:any, action:any) => {
            state.selectedChatPhase = action.payload;
            return state;
        },
        setSelectedStandardsChat: (state:any, action:any) => {
            state.selectedStandardsChat = action.payload;
            return state;
        },
        resetEvaluation: (state:any) => {
            state = initialData;
            return state;
        },
        setReportFoldersList: (state:any, action:any) => {
            state.reportFolders = action.payload;
            return state;
        },
        setSelectedReportEntity: (state:any, action:any) => {
            state.selectedReportEntity = action.payload;
            return state;
        },
        setIsSelectedReport: (state:any, action:any) => {
            state.isSelectedReport = action.payload;
            return state;
        },
        setReportData: (state:any, action:any) => {
            state.reportData = action.payload;
            return state;
        },
        resetReportData: (state:any) => {
            state.reportData = initialData.reportData;
            return state;
        },
        setStandardStatuses: (state:any, action:any) => {
            state.standardStatuses = action.payload;
            return state;
        },
        resetStandardStatuses: (state:any) => {
            state.standardStatuses = initialData.reportData;
            return state;
        },
        setIsFetchingInterviewDetails: (state:any, action:any) => {
            state.isFetchingInterviewDetails = action.payload;
            return state;
        },
        setExecutiveSummaryRichText: (state:any, action:any) => {
            state.executiveSummaryRichText = action.payload;
            return state;
        },
        setSelectedERStandard: (state:any, action:any) => {
            state.selectedERStandard = action.payload;
            return state;
        },
        resetSelectedERStandard: (state:any) => {
            state.selectedERStandard = initialData.reportData;
            return state;
        },
        setSelectedOffSiteStandard: (state:any, action:any) => {
            state.selctedOffSiteStandard = action.payload;
            return state;
        },
        resetSelectedOffSiteStandard: (state:any) => {
            state.selctedOffSiteStandard = initialData.reportData;
            return state;
        },
        setSelectedSaStandard: (state:any, action:any) => {
            state.selectedSaStandard = action.payload;
            return state;
        },
        resetSelectedSaStandard: (state:any) => {
            state.selectedSaStandard = initialData.reportData;
            return state;
        },
        setSelectedCommentBoxTab: (state:any, action:any) => {
            state.selectedCommentBoxTab = action.payload;
            return state;
        },
        setOnSiteSelectedCommentBoxTab: (state:any, action:any) => {
            state.onSiteSelectedCommentBoxTab = action.payload;
            return state;
        },
        setStructuredReportFoldersList: (state:any, action:any) => {
            state.structuredReportFolders = action.payload;
            return state;
        },
        setCriteriaCommentsHistory: (state:any, action:any) => {
            state.criteriaCommentsHistory = action.payload;
            return state;
        },
        resetCriteriaCommentsHistory: (state:any) => {
            state.criteriaCommentsHistory = initialData.criteriaCommentsHistory;
            return state;
        },
    }
})

export const { 
    setEvaluationSearchString,
    setCriteriaGroups,
    updateCurrentSection,
    setInitialSection,
    setSaCriteria,
    setSaStandards,
    resetSaStandards,
    setSelectedSaCriteria,
    resetSelectedSaCriteria,
    setSaActions,
    resetSaActions,
    setSaEvidences,
    resetSaEvidences,
    setSaComments,
    resetSaComments,
    setOffSiteEvaluation,
    resetOffSiteEvaluation,
    setOffSiteCriteria,
    setOffSiteStandards,
    setSelectedOffSiteCriteria,
    resetSelectedOffSiteCriteria,
    setOnSiteCriteria,
    setOnSiteDateGroups,
    setInterviewDetails,
    resetInterviewDetails,
    setOnSiteStandards,
    setSelectedOnSiteCriteria,
    resetSelectedOnSiteCriteria,
    setSelectedOnSiteSession,
    resetSelectedOnSiteSession,
    setInterviewers,
    setInterviewView,
    setInterviewTeams,
    setEvalReportCriteria,
    setEvalReportStandards,
    setSelectedEvalReportCriteria,
    resetSelectedEvalReportCriteria,
    resetOffSiteStandards,
    resetOnSiteStandards,
    resetEvalReportStandards,
    setActionsList,
    resetActionsList,
    setStaffList,
    resetStaffList,
    setProjectList,
    resetProjectList,
    setDepartmentList,
    resetDepartmentList,
    addNewSaAction,
    resetAddNewSaAction,
    setCurrentEvaluationTab,
    setCriteriaActions,
    resetCriteriaActions,
    setCriteriaEvidences,
    setSaCriteriaComments,
    setOffSiteCriteriaComments,
    setOnSiteCriteriaComments,
    setEvalCriteriaComments,
    setCommentContent,
    resetCommentContent,
    setSelectedCommentPhase,
    resetSelectedCommentPhase,
    setCriteriaComment,
    resetCriteriaComment,
    setSelectedChatPhase,
    setSelectedStandardsChat,
    setReportFoldersList,
    setSelectedReportEntity,
    setIsSelectedReport,
    resetEvaluation,
    setReportData,
    resetReportData,
    setStandardStatuses,
    resetStandardStatuses,
    setIsFetchingInterviewDetails,
    setExecutiveSummaryRichText,
    setSelectedERStandard,
    resetSelectedERStandard,
    setSelectedOffSiteStandard,
    resetSelectedOffSiteStandard,
    setSelectedCommentBoxTab,
    setOnSiteSelectedCommentBoxTab,
    setStructuredReportFoldersList,
    setCriteriaCommentsHistory,
    resetCriteriaCommentsHistory,
    setSelectedSaStandard,
    resetSelectedSaStandard,
 } = evaluation.actions;
export default evaluation.reducer;